/* =====================================================
Start: Reduce image saving options
Purpose:
- Disable right-click menu on images
- Disable dragging images to desktop or another tab
Note:
This does not fully prevent copying images, but makes saving them harder.
===================================================== */

document.addEventListener('contextmenu', function (e) {
  // Prevent right-click menu only when clicking on images
  if (e.target.closest('img')) {
    e.preventDefault();
  }
}, true);

document.addEventListener('dragstart', function (e) {
  // Prevent dragging images to desktop or another tab
  if (e.target.closest('img')) {
    e.preventDefault();
  }
}, true);

/* =====================================================
End: Reduce image saving options
===================================================== */